import { Ciudad } from './ciudad';

export class Sede {
  idSede: number;
  nombreSede: string;
  ciudad: Ciudad;
  indicadorHabilitado: boolean;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/sede.ts